/**
 * useLearnerHome — hook form of resolveLearnerHome (Issue #1521).
 *
 * Returns the flag-resolved learner-home path ('/messenger' | '/dashboard').
 * Must be called under BrandingProvider (true for every routed page).
 * Kept in a separate module from the pure resolver so context-free code and
 * node-env tests can import resolveLearnerHome without dragging in React
 * contexts (whose import chain touches `document`).
 */
import { useBranding } from '../../contexts/BrandingContext';
import { resolveLearnerHome } from './resolveLearnerHome';

export function useLearnerHome() {
  const branding = useBranding();
  return resolveLearnerHome(branding);
}
